import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import { Button } from '@crehana/compass.ui/button';
import { EmptyState } from '@crehana/compass.ui/empty-state';

import { useSuccessionCoverageTranslation } from '../i18n';

type TErrorViewProps = {
  onRetry: () => void;
  isSmall?: boolean;
};

export const ErrorView = ({ onRetry, isSmall = false }: TErrorViewProps) => {
  const { t } = useSuccessionCoverageTranslation();

  return (
    <EmptyState
      small={isSmall}
      className="tw-h-full tw-w-full !tw-pb-0 !tw-pt-1"
      icon={
        <div className="tw-p-0.4 tw-cds-bg-alert tw-rounded-full tw-flex tw-justify-center tw-items-center">
          <div className="tw-size-[5rem] tw-bg-alert-200 tw-rounded-full tw-flex tw-justify-center tw-items-center">
            <AlertTriangle size={24} className="tw-cds-text-feedback-alert" />
          </div>
        </div>
      }
      title={t('ERROR_TITLE')}
      description={t('ERROR_DESCRIPTION')}
      primaryAction={
        <Button type="button" variant="primary" size="xs" onClick={onRetry}>
          {t('ERROR_RETRY_BUTTON')}
        </Button>
      }
    />
  );
};
